const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-cta-section'] = {
        c: () => require('partner/modules/dobbies-cta-section/dobbies-cta-section.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-cta-section',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-cta-section'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-cta-section|dobbies-cta-section'] = {
                c: () => require('partner/modules/dobbies-cta-section/dobbies-cta-section.view.tsx'),
                cn: '__local__-__local__-dobbies-cta-section'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };